// This function allow to reference all chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 792) return "app-" + __webpack_require__.h() + ".bundle.js";
	// return url for filenames based on template
	return "" + chunkId + ".app-" + __webpack_require__.h() + ".bundle.js";
};